import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '@/components/ui/card'
import { featureSections, type FeatureSectionConfig } from '@/data/feature-sections'

export const FeatureGrid = ({ section }: { section: FeatureSectionConfig }) => {
    const Icon = section.icon
    return (
        <Card>
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Icon className="size-5 text-primary" />
                    {section.title}
                </CardTitle>
                <CardDescription>{section.description}</CardDescription>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {section.items.map((item, index) => (
                        <Card key={`${section.id}-${index}`}>
                            <CardHeader>
                                <CardTitle className="text-lg">{item.title}</CardTitle>
                                <CardDescription>{item.body}</CardDescription>
                            </CardHeader>
                        </Card>
                    ))}
                </div>
            </CardContent>
        </Card>
    )
}

export const FeatureSections = () => {
    return (
        <>
            {featureSections.map((section) => (
                <section key={section.id} id={section.id} className="mb-16 scroll-mt-16">
                    <FeatureGrid section={section} />
                </section>
            ))}
        </>
    )
}

